import { nanoid } from 'nanoid';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectMessages } from '../selectors';

const UNIQUE_MESSAGE_ERROR_CODES = [HTTP_RESPONSE_STATUS_CODES.UNAUTHORIZED];

export const MESSAGES_ACTION_TYPE = createNamedActions('messages', {
  HIDE_MESSAGE: 'HIDE_MESSAGE',
  SHOW_MESSAGE: 'SHOW_MESSAGE',
});

export const hideMessageAction = id => ({
  type: MESSAGES_ACTION_TYPE.HIDE_MESSAGE,
  payload: id,
});

export const showMessageAction = options => ({
  type: MESSAGES_ACTION_TYPE.SHOW_MESSAGE,
  payload: { ...options, id: options.id || nanoid() },
});

export const showErrorMessageAction = options => (dispatch, getState) => {
  const state = getState();
  const messages = selectMessages(state);

  const { err } = options;

  const errStatusCode = err?.response?.status;
  const isErrorWithUniqueCodeExists =
    UNIQUE_MESSAGE_ERROR_CODES.includes(errStatusCode) &&
    messages.some(message => message.err?.response?.status === errStatusCode);

  if (isErrorWithUniqueCodeExists) {
    return;
  }

  // A 401 raised while nobody is signed in tells the user nothing they can act on — they are
  // already looking at the login screen. It fires on a session-less boot because a stale token
  // (on iOS the keychain OUTLIVES app deletion) makes a protected call 401 before login, so a user
  // who has never signed in gets an error banner on every cold launch. Signed in, a 401 still
  // surfaces: there it means a live session just died, which is worth telling them about.
  // master.role is null until sign-in ("guest" in the reducer) — read defensively rather than
  // through getMasterRole, which destructures state.auth and state.auth.master and so throws on
  // the partial states thunk tests build.
  const isSignedIn = !!state?.auth?.master?.role;

  if (errStatusCode === HTTP_RESPONSE_STATUS_CODES.UNAUTHORIZED && !isSignedIn) {
    return;
  }

  return dispatch(showMessageAction({ variant: 'error', ...options }));
};
